import { type FC } from 'react';


interface InlineMessageProps {
    status: 'info' | 'warning' | 'error' | 'success';
    children: React.ReactNode;
}

const InlineMessage: FC<InlineMessageProps> = ({ children, status = 'error' }) => {
    return (
        <div className={`inline-message status-${status}`}>
            {children}
        </div>
    );
};

export default InlineMessage;
